import React, { useState } from 'react';
import { CgClose } from "react-icons/cg";
import productCategory from '../helpers/productCategory';
import { FaCloudUploadAlt } from "react-icons/fa";
import uploadImage from '../helpers/uploadImage';
import DisplayImage from './DisplayImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AdminEditProduct = ({ onClose, productData, fetchData }) => {

    const[ data,setData ] = useState({
        ...productData,
        productName : productData?.productName,
        brandName : productData?.brandName,
        category : productData?.category,
        productImage : productData?.productImage || [],
        description : productData?.description,
        price : productData?.price,
        sellingPrice : productData?.sellingPrice,
        productCode : productData?.productCode,
        gst: productData?.gst ?? 18,
        hsn: productData?.hsn ?? "",
        stock: productData?.stock ?? 0
    })

    const [ openFullScreenImage, setOpenFullScreenImage ] = useState(false)
    const [ fullScreenImage, setFullScreenImage ] = useState("")

    const handleOnChange = (e) => {
        const { name, value } = e.target

        setData((preve)=>{
            return{
                ...preve,
                [name] : value
            }
        })
    }

    const handleUploadProduct = async (e) => {
        const file = e.target.files[0]
        const uploadImageCloudinary = await uploadImage(file)

        setData((preve)=>{
            return{
                ...preve,
                productImage : [ ...preve.productImage, uploadImageCloudinary.secure_url ]
            }
        })
    }

    const handleDeleteProductImage = async(index) => {
        const newProductImage = [...data.productImage]
        newProductImage.splice(index,1)

        setData((preve)=>{
            return{
                ...preve,
                productImage : [ ...newProductImage ]
            }
        })
    }

    // upload product
    const handleSubmit = async (e) => {
        e.preventDefault()

        const response = await fetch(SummaryApi.updateProduct.url,{
            method : SummaryApi.updateProduct.method,
            credentials : "include",
            headers : {
                "Content-Type" : "application/json"
            },
            body : JSON.stringify(data)
        });

        const responseData = await response.json();
        
        if(responseData.success)
            toast.success(responseData?.message)
            onClose()
            fetchData()

        if(responseData.error)
            toast.error(responseData?.message)

    }

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
        <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
            
            <div className='flex justify-between items-center pb-3'>
                <h2 className='font-bold text-lg'>Edit Products</h2>
                <div className='w-fit ml-auto text-2xl hover:text-[#5a3620] cursor-pointer' onClick={onClose}>
                    <CgClose />
                </div>
            </div>

            <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-4' onSubmit={handleSubmit}>
                <label htmlFor='productName'>Product Name :</label>
                <input 
                    type='text' 
                    id='productName' 
                    placeholder='enter product name' 
                    name='productName'
                    value={data.productName} 
                    onChange={handleOnChange} 
                    className='p-2 bg-slate-100 border rounded'
                    required
                />

                <label htmlFor='productCode'>Product Code :</label>
                <input 
                    type='text' 
                    id='productCode' 
                    placeholder='enter product code' 
                    name='productCode'
                    value={data.productCode} 
                    onChange={handleOnChange} 
                    className='p-2 bg-slate-100 border rounded'
                    required
                />

                <label htmlFor='brandName' className='mt-3'>Brand Name :</label>
                <input 
                    type='text' 
                    id='brandName' 
                    placeholder='enter brand name'
                    name='brandName' 
                    value={data.brandName} 
                    onChange={handleOnChange} 
                    className='p-2 bg-slate-100 border rounded'
                    required
                />

                <label htmlFor='category' className='mt-3'>Category :</label>
                <select required value={data.category} name='category' onChange={handleOnChange} className='p-2 bg-slate-100 border rounded'>
                <option value={""}>Select Category :</option>
                    {
                        productCategory.map((el,index)=>{
                            return(
                                <option value={el.value} key={el.value+index}>{el.label}</option>
                            )
                        })
                    }
                </select>

                {/* GST */}
                <label className="mt-3">GST Rate :</label>
                <select name="gst" value={data.gst} onChange={handleOnChange} className="p-2 bg-slate-100 border rounded" required>
                    <option value={0}>0%</option>
                    <option value={3}>3%</option>
                    <option value={5}>5%</option>
                    <option value={12}>12%</option>
                    <option value={18}>18%</option>
                </select>

                {/* HSN */}
                <label className="mt-3">HSN Code :</label>
                <input
                    type="text"
                    name="hsn"
                    placeholder="Enter HSN code"
                    value={data.hsn}
                    onChange={handleOnChange}
                    className="p-2 bg-slate-100 border rounded"
                    required
                />


                <label htmlFor='productImage' className='mt-3'>Product Image :</label>
                <label htmlFor='uploadImageInput'>
                    <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
                        <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                            <span className='text-3xl'><FaCloudUploadAlt /></span>
                            <p className='text-sm'>Upload Product Image</p>
                            <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadProduct}/>
                        </div>
                    </div>
                </label>
                <div>
                    {
                        data?.productImage[0] ? (
                            <div className='flex items-center gap-2'>
                                {
                                    data.productImage.map((el, index)=>{
                                        return(
                                            <div className='relative group'>
                                                <img 
                                                src={el} 
                                                alt={el} 
                                                className='bg-slate-100 border h-20 w-20 cursor-pointer' 
                                                onClick={()=>{
                                                    setOpenFullScreenImage(true)
                                                    setFullScreenImage(el)
                                                }} />

                                                <div className='absolute bottom-0 right-0 p-1 bg-[#5a3620] text-white rounded-full hidden group-hover:block cursor-pointer' onClick={()=>handleDeleteProductImage(index)}>
                                                    <MdDelete/>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>   
                        ) : (
                            <p className='text-red-600 text-xs'>*Please upload product image</p>
                        )
                    }
                </div>

                <label htmlFor='price' className='mt-3'>Price :</label>
                <input 
                    type='number' 
                    id='price' 
                    placeholder='enter price'
                    name='price' 
                    value={data.price} 
                    onChange={handleOnChange} 
                    className='p-2 bg-slate-100 border rounded'
                    required
               />

                <label htmlFor='sellingPrice' className='mt-3'>Selling Price :</label>
                <input 
                    type='number' 
                    id='sellingPrice' 
                    placeholder='enter selling price'
                    name='sellingPrice' 
                    value={data.sellingPrice} 
                    onChange={handleOnChange} 
                    className='p-2 bg-slate-100 border rounded'
                    required
                />

                <label htmlFor="stock" className="mt-3">Stock Quantity :</label>
                <input
                    type="number"
                    id="stock"
                    name="stock"
                    value={data.stock}
                    onChange={handleOnChange}
                    min="0"
                    className="p-2 bg-slate-100 border rounded"
                    required
                />

                <label htmlFor='description' className='mt-3'>Description :</label>
                <textarea 
                    className='h-28 bg-slate-100 border resize-none p-1' 
                    placeholder='enter product description' 
                    rows={3} 
                    onChange={handleOnChange} 
                    name='description'
                    value={data.description}
                >
                </textarea>



                <button className='px-3 py-2 bg-[#5a3620] text-white mb-10'>Update Product</button>

            </form>
        </div>

        {/**display image full screen */}
        {
            openFullScreenImage && (
                <DisplayImage onClose={()=>setOpenFullScreenImage(false)} imgUrl={fullScreenImage}/>
            )
        }
    </div>
  )
}

export default AdminEditProduct